import decode from "jwt-decode";
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";


export const logInAsync = createAsyncThunk(
  'session/logIn',
  async (value) => {
    try {
      const response = await axios.post('/api/v1/auth/sign_in', value);
      return response.data;
    } catch (e) {
      return null
    }
  }
);

export const changePasswordAsync = createAsyncThunk(
  'session/changePassword',
  async (value) => {
    const response = await axios.post('/api/v1/users/change_password', value);
    return response.data;
  }
);

export const updateUserAsync = createAsyncThunk(
  'session/updateUser',
  async ({userId, value}) => {
    const response = await axios.put('/api/v1/users/' + userId, value);
    return response.data;
  }
);

export const getPermissionsAsync = createAsyncThunk(
  'session/getPermissions',
  async () => {
    const response = await axios.get('/api/v1/permissions');
    return response.data;
  }
);
export const signUpAsync = createAsyncThunk(
  'session/signUp',
  async (value) => {
    try{
    const response = await axios.post('/api/v1/auth/sign_up', value);
    return response.data;
  }catch(e){
      return null
  }
  }
);

export const sendResetPasswordAsync = createAsyncThunk(
  'session/sendResetPassword',
  async (value) => {
    try{
    const {data} = await axios.post('/api/v1/auth/reset_password', value);
    return data;
    }catch(e){

      return null
    }
  }
);

export const resetPasswordAsync = createAsyncThunk(
  'session/resetPassword',
  async ({value, token}) => {
    const {data} = await axios.post('/api/v1/auth/reset_password/' + token, value);
    if (!data.token) {

    }
    return data;
  }
);

export const isTokenExpired = (token) => {
  try {
      const decoded = decode(token);
      return decoded.exp < Date.now() / 1000;
  }
  catch (err) {
    console.log(err);
    return true;
  }
}
const token = localStorage.getItem("token");
const payload  = token ? decode(token) : {};
const initialState = {
  currentProject: 1,
  token: token,
  id: payload.id,
  email: payload.email,
  name: payload.name,
  admin: payload.admin,
  permissions: [],
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetResetPasswordMsg: (state, action) => {
      state.resetPasswordMsg = payload.msg;
    },
    setToken: (state, action) => {
      localStorage.setItem("token", action.payload);
      const decoded = decode(action.payload);
      state.token = action.payload;
      state.id = decoded.id;
      state.name = decoded.name;
      state.admin = decoded.admin;
      state.email = decoded.email;
    },
    logOut: (state) => {
      localStorage.clear();
      sessionStorage.clear();
      state.token = null;
      state.id = null;
      state.name = null;
      state.admin = null;
      state.type = null;
      state.email = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(logInAsync.fulfilled, (state, action) => {
          if (action.payload) {
            localStorage.setItem("token", action.payload);
            const decoded = decode(action.payload);
            state.token = action.payload;
            state.id = decoded.id;
            state.name = decoded.name;
            state.admin = decoded.admin;
            state.email = decoded.email;
          }
      })
      .addCase(updateUserAsync.fulfilled, (state, {payload}) => {
          localStorage.setItem("token", payload);
          const decoded = decode(payload);
          state.token = payload;
          state.id = decoded.id;
          state.name = decoded.name;
          state.admin = decoded.admin;
          state.email = decoded.email;
    
      })
      .addCase(signUpAsync.fulfilled, (state, {payload}) => {
        if(payload){ 
            state.signUpMsg = payload.msg;
          if (payload.token) {
            state.signUpMsg = '';
            localStorage.setItem("token", payload.token);
            const decoded = decode(payload.token);
            state.token = payload.token;
            state.id = decoded.id;
            state.name = decoded.name;
            state.admin = decoded.admin;
            state.email = decoded.email;
          }
        }
      })
      .addCase(sendResetPasswordAsync.fulfilled, (state, {payload}) => {
        if(payload){
           state.resetPasswordMsg = payload.msg;
          }
      })
      .addCase(getPermissionsAsync.fulfilled, (state, {payload}) => {
          state.permissions = JSON.parse(atob(payload));
      })
      .addCase(resetPasswordAsync.fulfilled, (state, {payload}) => {
        if (payload.token) {
          state.signUpMsg = '';
          localStorage.setItem("token", payload.token);
          const decoded = decode(payload.token);
          state.token = payload.token;
          state.id = decoded.id;
          state.name = decoded.name;
          state.admin = decoded.admin;
          state.email = decoded.email;
        }
      })
    }
});

export const currentProject = (state) => state.session.currentProject;
export const isLoggedIn = (state) => !!state && !!state.session.token && !isTokenExpired(state.session.token);
export const getSession = (state) => state.session
export const getPermissions = (state) => state.session.permissions
export const getSignUpMsg = (state) => state.session.signUpMsg
export const getResetPasswordMsg = (state) => state.session.resetPasswordMsg

export const setAuthorizationHeaders = (config) => (dispatch, getState) => {
  let state = getState();
  if (state.session && state.session.token){
    config.headers['Authorization'] = "Bearer " + state.session.token;
  }
};



export const { setToken, logOut, resetResetPasswordMsg } = userSlice.actions;

export default userSlice.reducer;
